import { render, staticRenderFns } from "./DedicatedPayment.vue?vue&type=template&id=6c4f1720&scoped=true"
import script from "./DedicatedPayment.vue?vue&type=script&lang=js"
export * from "./DedicatedPayment.vue?vue&type=script&lang=js"
import style0 from "./DedicatedPayment.vue?vue&type=style&index=0&id=6c4f1720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4f1720",
  null
  
)

export default component.exports